<template>
  
  <div class="typage">
    <div class="grid mt-1">
      <div class="cell">
        <div class="has-text-centered">
          <p> {{  $t('ThankYouMessage.p_1')  }} </p>
          <p v-if="fromSurvey"> {{  $t('ThankYouMessage.p_survey')  }} </p>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
// @ is an alias to /src
// import apiclient from '@/apiclient.js'
import gnetMixLib from '@/mixin.js'

export default {
  name: 'ThankYouPage',
  mixins: [gnetMixLib],
  components: {
  },
  
  props: {
    fromSurvey: Boolean
  },
  
  data: function() {
    return { };
  },
  
  computed: { },
  
  created: async function() {
    
  },
  
  mounted: async function() {
    
  },
  
  methods: {
    
  },
}

</script>

<style scoped>
</style>

